import { toast } from "react-toastify";
import { call, takeEvery, put } from "redux-saga/effects";
import { createDocketAction } from "../../api/docketActions/docket-action";

function* createDocketSaga(action) {
  try {
    const response = yield call(createDocketAction, action.payload);
    if (response.status === 200) {
      toast.success("docket created");
    }
  } catch (error) {
    toast.error(error.response.data.message);
  }
}

export function* watchDocketSaga() {
  yield takeEvery("CREATE_DOCKET", createDocketSaga);
}
